module.exports = __webpack_public_path__ + "img/bubble-thumbsdown.80390a25.svg";